export const materialReturnDicionaryError: Record<string, string> = {
  'ultracar.errors.services.return_greater_than_delivered':
    'A quantidade de retorno está maior que a quantidade entregue!',
};
